/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Mass_BodyInputs */

const en_for_whom_mass_body = /** @type {(inputs: For_Whom_Mass_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The plan picks the weight and the reps, and recovery makes sure every muscle has time to grow.`)
};

const pl_for_whom_mass_body = /** @type {(inputs: For_Whom_Mass_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan dobiera ciężar i powtórzenia, a regeneracja pilnuje, żeby każda partia miała czas urosnąć.`)
};

/**
* | output |
* | --- |
* | "The plan picks the weight and the reps, and recovery makes sure every muscle has time to grow." |
*
* @param {For_Whom_Mass_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_mass_body = /** @type {((inputs?: For_Whom_Mass_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Mass_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_mass_body(inputs)
	return en_for_whom_mass_body(inputs)
});